// extracted by mini-css-extract-plugin
module.exports = {"SectorHexagons":"styles_SectorHexagons__Zwzo2","bg_1":"styles_bg_1__Gnbqs","bg_2":"styles_bg_2__Dwq5S","height":"styles_height__YpNfp"};